module.exports = __webpack_public_path__ + "img/PL09006.284edd70.png";